import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericGetData } from 'src/app/core/models/get-data.model';
import { GlobalComponent } from 'src/app/global-component';
import { GetSubProceso } from '../models/subproceso.model';
import { SelectOptionResponse } from 'src/app/shared/models/generic-entities.model';

@Injectable({
  providedIn: 'root'
})
export class SubProcesoService {

  private urlService = 'configuraciones/subproceso/';

  constructor(private http: HttpClient) { }

  new(data: any) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"save"}`, data, { reportProgress: true, observe: "events" });
  }

  edit(data: any) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"edit"}`, data, { reportProgress: true, observe: "events" });
  }


  getAll(page: number, pageSize: number, filter: string) {
    let urlFilter = page === 0 || pageSize === 0 ? "" : `?pageNumber=${page}&pageSize=${pageSize}&filter=${filter}`;
    return this.http.get<GenericGetData<GetSubProceso[]>>(`${GlobalComponent.API_URL}${this.urlService}${"getall"}${urlFilter}`, { reportProgress: true, observe: "events" });
  }

  getSelectProcesoSubproceso(procesoId: string) {
    let urlFilter = `/select?id=${procesoId}`;
    return this.http.get<SelectOptionResponse[]>(`${GlobalComponent.API_URL}configuraciones/procesosubproceso${urlFilter}`, { reportProgress: true, observe: "events" });
  }

  getSelectSubproceso(procesoId: string) {
    let urlFilter = `select?id=${procesoId}`;
    return this.http.get<SelectOptionResponse[]>(`${GlobalComponent.API_URL}${this.urlService}${urlFilter}`, { reportProgress: true, observe: "events" });
  }
}
